import React, {Component} from 'react';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment-timezone';

//Force all dates to be in UTC.
moment.tz.setDefault('Etc/UTC');

export class DateUtilsProvider extends Component<{ children?: any; }, {}> {
    public render() {
        return (
            <MuiPickersUtilsProvider utils={MomentUtils}>
                {this.props.children}
            </MuiPickersUtilsProvider>
        );
    };
}

export default DateUtilsProvider;